export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            关于极速影视
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            打造一站式高清影视聚合平台
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-movie-2-line text-primary-500 text-2xl md:text-3xl"></i>
            </div>
            <div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-4">
                极速影视 · 你的私人追剧助手
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                极速影视成立于2024年，致力于为广大影迷提供最新、最全、最流畅的在线观影体验。我们与多家正版内容平台合作，每日同步更新最新上映电影、热播电视剧全集以及热门综艺节目单，覆盖动作、悬疑、爱情、喜剧、科幻、纪录片等全品类内容。
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                平台采用先进的视频分发技术，确保高清画质下流畅播放不卡顿，让你无论使用电脑、平板还是手机，都能获得极致的追剧体验。极速影视最新电影大全每日更新，追剧不停歇！
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}